export function isLocalDevHostname(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }
  const { hostname } = window.location;
  return hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '[::1]' || hostname === '::1';
}

/**
 * Build the URL for browser `fetch` calls.
 * On localhost, use the page origin so rspack dev-server proxies `/api` → Express (port 3002).
 * Otherwise use `API_HOST` (e.g. test/prod CDN) like the rest of the admin services.
 */
export function resolveApiUrl(path: string): string {
  if (typeof window === 'undefined') {
    return path.startsWith('/') ? path : `/${path}`;
  }

  const normalized = path.startsWith('/') ? path : `/${path}`;
  const { origin } = window.location;

  if (isLocalDevHostname()) {
    return `${origin}${normalized}`;
  }

  const base = String(window.configs?.API_HOST ?? '').replace(/\/$/, '');
  return `${base}${normalized}`;
}
